import React from 'react'
import { useParams } from 'react-router-dom'

const Contact = () => {
  console.log("This is contact Page :")
  // const params = useParams()
  // console.log(params)
  return (
    <>
      <h1>Welcome to Contact Page</h1>
    </>
  )
}

export default Contact
